import './index.scss';

import ModalItem from '../modalItem';
import { useState } from 'react';

export default function ItemEstoque() {
    const [openModal, setOpenModal] = useState(false);

    function AtivaModal() {
        setOpenModal(true); 
    }

    function FechaModal() {
        setOpenModal(false); 
    }

    return (
        <div className='comp-itemEstoque' >
    
            <ModalItem isOpen={openModal} closeModal={FechaModal} />
            <div className='container-itemEstoque' onClick={AtivaModal}>
                <h1>Maquina rotativa xcore</h1>
                <img src="./assets/images/estoque/maquina.png" alt="Item" />
                <div className='quantidade'>
                    <p>1</p>
                    <p>/</p>
                    <p>2</p>
                </div>
            </div>
        </div>
    );
}
